// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","uploadWrapper":"file-upload-button_uploadWrapper__jhHZ0","hiddenInput":"file-upload-button_hiddenInput__xkQPw"};